import React from 'react'
import { Job, JobWizard } from 'sprockets_react/job_wizards/registries'

JobWizard.CloseModalWarning = function(props) {
  return (
    <div className="close-modal-warning" style={{display: 'none'}}>
      {props.hideNotPostedWarningMessage || Job.Data.id ? '' : <p className="bold">Your job has NOT been posted!</p>}
      {Job.Data.id ? <p className="bold">Are you sure you want to close?</p> : <p>Are you sure you want to exit?</p>}
      <div className="row">
        <div className="col-sm-6">
          <a href="#" className="btn btn-block btn-clear btn-white font-12 modal-exit">
            { Job.Data.id && !Job.Data.lastSlide ? 'Invite Businesses Now' : 'Exit' }
          </a>
        </div>
        <div className="col-sm-6">
          <a href="#" className="btn btn-block btn-white font-12 modal-stay" style={{color: 'red'}}>
            { Job.Data.id && !Job.Data.lastSlide ? 'Let me add more info first' : 'Stay & Continue' }
          </a>
        </div>
      </div>
    </div>
  )
}
